import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    startDate: null,
    endDate: null,
    leadType: "",
    status: "",
    flagged: "",
    minDuration: "",
    pnls: [],
    teams: [],
    agents: [],
  },
  rows: [],
  fetched: false,
  shouldRefresh: false,
};

const callLogsReportSlice = createSlice({
  name: "callLogsReport",
  initialState,
  reducers: {
    saveCallLogsReport(state, action) {
      state.filter = action.payload.filter;
      state.rows = action.payload.rows;
      state.fetched = action.payload.fetched;
      state.shouldRefresh = Boolean(action.payload.shouldRefresh);
    },

    clearCallLogsReport(state) {
      state.filter = initialState.filter;
      state.rows = [];
      state.fetched = false;
    },
  },
});

export const {
  saveCallLogsReport,
  clearCallLogsReport,
} = callLogsReportSlice.actions;

export default callLogsReportSlice.reducer;
